import { DaaSNotification, NotificationEventType } from "@/services/api/contracts/notifications"
import { FC } from "react";
import TestNotification from "./TestNotification";
import { isNotificationRead } from "@/services/notifications/useNotifications";

interface ExternalNotificationCardProps {
  notification: DaaSNotification;
  onClick?: () => void;
}

export interface NotificationCardProps extends ExternalNotificationCardProps {
  read: boolean;
}

export const NotificationCard: FC<ExternalNotificationCardProps> = (extProps) => {
  const read = isNotificationRead(extProps.notification);
  const props = {
    read,
    ...extProps
  }

  switch (extProps.notification.notificationEventType) {
    case NotificationEventType.TEST:
      return <TestNotification {...props} />
    default:
      throw Error("Unknown notification type detected")
  }
}